"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject()),
    ContentWrapper = _createStyled["default"].div(_templateObject2()),
    Label = _createStyled["default"].label(_templateObject3()),
    FieldWrapper = _createStyled["default"].div(_templateObject4()),
    Border = _createStyled["default"].hr(_templateObject5()),
    Field = _createStyled["default"].input(_templateObject6());

function template() {
  var label = null,
      styles = this.compileStyled(_index["default"]),
      error = this.props.error,
      focus = this.state.focus;

  if (this.props.label) {
    label = _react["default"].createElement(Label, {
      styles: styles.label
    }, this.props.label);
  }

  var i = 0,
      input = [];

  for (i; i < this.props.count; i++) {
    var id = this.id + i,
        attributes = {
      type: this.props.type,
      styles: !error && focus === id ? styles.fieldFocused : styles.field,
      autoComplete: this.props.autoComplete,
      placeholder: this.props.placeholder || '',
      key: "input-".concat(i),
      onFocus: this._handleCellFocus,
      onBlur: this._handleCellBlur,
      onChange: this._handleCellChange,
      onKeyDown: this._handleCellKeyDown,
      onPaste: this._handlePaste,
      ref: this._makeInputRef,
      id: id,
      // readOnly: this._isDisabled(id),
      value: this.state[id] || '',
      // last input must be limited by maxLength
      maxLength: i === this.props.count - 1 ? this.props.maxLength : null,
      'data-qa-node': this.props.attribute + '-' + i,
      'data-qa-value': this.state[id] || '',
      disabled: this.props.disabled
    };
    input.push(_react["default"].createElement(FieldWrapper, {
      styles: styles.wrapper,
      key: "input-wrapper".concat(i)
    }, _react["default"].createElement(Field, attributes), _react["default"].createElement(Border, {
      styles: styles.border
    }), _react["default"].createElement(Border, {
      styles: !error && focus === id ? styles.activeBorderFocused : styles.activeBorder
    })));
  }

  return _react["default"].createElement(Root, {
    className: this.props.className || '',
    styles: styles.root
  }, _react["default"].createElement(ContentWrapper, {
    onMouseEnter: this._handleHover,
    onMouseLeave: this._handleRootBlur,
    styles: styles.contentWrapper
  }, label, input));
}